<template>
        <div v-if="status_lapse !== null && home">
            <div class="container" @click="redirectWinPoints()">
                <div href="/retos" :class="{
                    'streak-container': status_lapse === 'in_warning' || seasonStreak === 'lose',
                    'streak-container-season' : status_lapse === 'in_progress' || status_lapse === 'in_coming' || status_lapse === 'completed'
                  }" class=" d-flex flex-column flex-md-row justify-content-between align-items-center rounded p-3">

                    <!-- Mobile: versión  -->
                    <div class="home-container-status-season" style="color: #0d0d0d;">
                      <a class="text-decoration-none cursor-pointer text-black">
                        <div class="streak-mobile-custom text-center" >
                          <div class="col-4 mt-2">
                            <strong class="mt-4 text-bat text-black">{{ getSeasonTitle() }}</strong>
                          </div>
                          <div class="col-8 d-flex justify-content-center mt-2 flex-wrap" >
                            <div class="d-flex justify-content-center gap-2">
                              <div v-if="season && season.lapses" v-for="(lapse, index) in season.lapses" :key="index" class="text-center">
                                <img :src="getStaffLapseImage(lapse)" :alt="'Día ' + (index + 1)" class="icon-fire-home" />
                                <div>
                                  <p :class="{ 'text-red': lapse.id === defaultLapseId, 'text-bat' : lapse.id !== defaultLapseId }">{{ index + 1 }}°</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>

                      <!-- Desktop: versión  -->
                      <a class="text-decoration-none cursor-pointer text-black">
                        <div class="streak-desktop d-none d-md-block me-md-4">
                          <strong class="text-black">{{ getSeasonTitle() }}</strong>
                          <div class="d-flex justify-content-start mt-2 flex-wrap">
                            <div class="d-flex justify-content-center gap-4">
                              <div v-if="season && season.lapses" v-for="(lapse, index) in season.lapses" :key="index" class="text-center">
                                <img :src="getStaffLapseImage(lapse)" :alt="'Día ' + (index + 1)" class="icon-fire-home" />
                                <div>
                                  <p :class="{ 'text-red': lapse.id === defaultLapseId, 'text-bat' : lapse.id !== defaultLapseId }">{{ index + 1 }}°</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>


                    <div class="message-box d-flex align-items-center p-3">
                        <img :src="getSeasonImage()" alt="Perro motivado" class="dog-img me-3" />
                        <div class="text-white">
                            <div class="bubble-message">{{ getSeasonDescription(true) }}</div>
                            <div class="small">{{ getSeasonDescription() }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div v-else-if="status_lapse !== null && !home" class="col-12 col-md-6 description-win">
          <div class="container">
            <div :class="{
            'streak-container': status_lapse === 'in_warning' || seasonStreak === 'lose',
            'streak-container-season' : status_lapse === 'in_progress' || status_lapse === 'in_coming' || status_lapse === 'completed'
          }" class="d-none d-md-none d-xl-block d-lg-block">
              <div class="d-flex flex-column flex-md-row flex-lg-row justify-content-between align-items-center rounded p-3 abstract-season-desk">
                <div class="streak-desktop me-md-4">
                  <div class="d-flex justify-content-start mt-2 flex-wrap">
                    <div v-if="season && season.lapses" v-for="(lapse, index) in season.lapses" :key="index" class="text-center mx-2">
                      <img :src="getStaffLapseImage(lapse)" :alt="'Día ' + (index + 1)" class="icon-fire-win-points" />
                      <div>
                        <p :class="{ 'text-red': lapse.id === defaultLapseId }">{{ index + 1 }}ª</p>
                      </div>
                    </div>
                    <div class="">
                      <button class="w-100 mx-1 btn text-title-bat rounded-3 btn-season" @click="showSeasonModal = true">
                        <span>Ver actividades de racha </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="message-box d-flex align-items-center p-3 mt-2 mt-md-0">
                  <img :src="getSeasonImage()" alt="Perro motivado" class="image-abstract me-1" />
                  <div class="text-white">
                    <div class="small">{{ getSeasonTitleWinPoints() }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div :class="{
            'streak-container': status_lapse === 'in_warning' || seasonStreak === 'lose',
            'streak-container-season' : status_lapse === 'in_progress' || status_lapse === 'in_coming' || status_lapse === 'completed'
          }"  class="abstract-season-mobile d-block d-md-block d-lg-none d-xl-none">
              <div class="align-items-center rounded-3 p-3 mt-3 ">
                <div class=" p-1 rounded text-center">
                  <div class="d-flex justify-content-center gap-5">
                    <div v-if="season && season.lapses" v-for="(lapse, index) in season.lapses" :key="index" class="text-center">
                      <img :src="getStaffLapseImage(lapse)" :alt="'Día ' + (index + 1)" class="icon-fire-home" />
                      <div>
                        <p :class="{ 'text-red': lapse.id === defaultLapseId }">{{ index + 1 }}°</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Box azul con el perro -->
                <div class="bg-dark-blue text-white d-flex align-items-center rounded p-3 mb-1 justify-content-center">
                  <img :src="getSeasonImage()" alt="Perro"
                       style="width: 100px; height: 100px;" />
                  <strong>{{ getSeasonTitleWinPoints() }}</strong>
                </div>

                <!-- Botón -->
                <div class="">
                  <button class="w-100 mx-1 btn text-title-bat rounded-3 btn-season" @click="showSeasonModal = true">
                    <span>Ver actividades de racha </span>
                  </button>
                </div>

              </div>
            </div>
          </div>


            <el-dialog :visible.sync="showSeasonModal" :width="$mq === 'sm' ? '95%' : 'md' ? '35%' : '20%'"
                       :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true">
                <div v-if="activeSeason != null">
                    <season :season_id="activeSeason.id" :staff_segments="segments_staff" :client_segment="client_segment"

                    ></season>
                </div>
            </el-dialog>
        </div>
  </template>

<script>

export default {
    props: {
        client_segment : null,
        segments_staff : null,
        home: false
    },
    data() {
        return {
            streakIcons: [
                { src: '/img-version2/icons/season-staff/season-won.gif' },
                { src: '/img-version2/icons/season-staff/season-current.gif' },
                { src: '/img-version2/icons/season-staff/season-won.gif' },
                { src: '/img-version2/icons/season-staff/season-current.gif' }
            ],
            season: { lapses: [] },
            current_date: null,
            loading: 0,
            activeSeason: null,
            activeLapse: null,
            defaultLapseId: null,
            selected_lapse: null,
            selected_lapse_start_date: null,
            activities: null,
            goalActivities: null,
            totalActivitiesCompleted: null,
            inactiveLapses: [],
            status_lapse: null,
            showSeasonModal: false,
            seasonStreak: null,
            finishedSeason: false,
            missingPoints: 0,
        }
    },
    mounted() {
        this.getActiveSeason();
    },
    methods: {
        getActiveSeason() {
            this.loading++
            axios.get(`/get-active-season`)
                .then(({ data }) => {
                    this.activeSeason = data.season;
                    this.status_lapse = data.active_lapse;
                    this.seasonStreak = data.season_streak;
                    this.finishedSeason = data.finished_season;
                    this.getSeasonData(data.season.id);
                    this.getMissingPoints();
                    this.loading--
                })

        },
        getSeasonData(id) {
            this.loading++
            axios.get(`/get-season-data/${id}`)
                .then(({ data }) => {
                    this.season = data.season;
                    this.current_date = data.current_date;
                    this.loading--
                    this.checkActiveLapse()
                })
        },
        checkActiveLapse() {

            if (!this.season || !this.season.lapses || this.season.lapses.length === 0) {
                return;
            }

            this.inactiveLapses = [];
            const current_date = this.current_date ? new Date(this.current_date) : new Date();

            for (const lapse of this.season.lapses) {
                const startDate = new Date(lapse.start_date);
                const endDate = new Date(lapse.end_date);

                if (current_date >= startDate && current_date <= endDate) {
                    this.activeLapse = lapse;
                    break;
                }

            }

            if (this.activeLapse == null && this.season && this.season.lapses.length > 0) {
                this.activeLapse = this.season.lapses[this.season.lapses.length - 1];
            }

            if (this.activeLapse) {
                this.defaultLapseId = this.activeLapse.id;
                this.selected_lapse = this.activeLapse.id;
                this.getLapseActivities(this.activeLapse.id);
            }

            this.inactiveLapses = this.season.lapses.filter(lapse => lapse.id !== this.activeLapse?.id);
        },
        getLapseActivities(lapse_id) {
            const selectedLapse = this.season.lapses.find(lapse => lapse.id === lapse_id);
            const lapseStartDate = new Date(selectedLapse.start_date);
            const current_date = this.current_date ? new Date(this.current_date) : new Date();
            const currentDate = new Date(current_date);
            if (lapseStartDate > currentDate) {
                this.selected_lapse_start_date = lapseStartDate;
                return;
            }
            this.selected_lapse = lapse_id;
            this.selected_lapse_start_date = lapseStartDate;
            this.loading++;
            axios.get(`/get-lapse-activities/${this.selected_lapse}`)
                .then(({ data }) => {
                    this.activities = (data.activities || []).filter(activity => activity.has_quiz !== 0);
                    this.goalActivities = this.activities.length;
                    this.totalActivitiesCompleted = this.activities.reduce((total, activity) => {
                        let isCompleted = false;
                        // Validaciones para determinar si la actividad está completada
                        if (activity.option === 'challenge') {
                            // Validación "challenge"
                            if (activity.current_client && activity.current_client.length > 0) {
                                const client = activity.current_client[0];
                                isCompleted = client.pivot.is_approved === 'true' ||
                                    client.pivot.is_approved === 'false' ||
                                    client.pivot.is_approved === 'review';
                            }
                        } else if (activity.option === 'learning') {
                            if (activity.current_client && activity.current_client.length > 0) {
                                const client = activity.current_client[0];
                                isCompleted = client.pivot.status === 'completed' &&
                                    client.pivot.quiz_presented === 1;
                            }
                        } else if (activity.option === 'finish') {
                            if (activity.current_client && activity.current_client.length > 0) {
                                const client = activity.current_client[0];
                                isCompleted = client.pivot.status === 'finish';
                            }
                        } else if (activity.option === 'survey') {
                            if (activity.current_client && activity.current_client.length > 0) {
                                const client = activity.current_client[0];
                                isCompleted = client.pivot.status === 'finish';
                            }
                        } else if (activity.option === 'entertainment') {
                            if (activity.current_client && activity.current_client.length > 0) {
                                const client = activity.current_client[0];
                                isCompleted = client.pivot.status === 'true';
                            }
                        }

                        return total + (isCompleted ? 1 : 0);
                    }, 0);
                    this.loading--;
                })
                .catch(() => {
                    this.loading--;
                });
        },
        getStaffLapseImage(lapse) {
            const currentDate = this.current_date ? new Date(this.current_date) : new Date();
            const lapseEndDate = new Date(lapse.end_date);
            const lapseStartDate = new Date(lapse.start_date);

            const clientCompletedAll =
                lapse.current_client.length &&
                lapse.current_client[0].pivot.completed_activities === lapse.activities;

            if (currentDate < lapseStartDate) {
                return '/img-version2/icons/season-staff/blocked-flame.png';
            } else if (currentDate >= lapseStartDate && currentDate <= lapseEndDate) {
                return clientCompletedAll
                    ? '/img-version2/icons/season-staff/season-won.gif'
                    : '/img-version2/icons/season-staff/season-current.gif';
            } else if (currentDate > lapseEndDate) {
                return clientCompletedAll
                    ? '/img-version2/icons/season-staff/season-won.gif'
                    : '/img-version2/icons/season-staff/gray-flame.png';
            } else {
                return '/img-version2/icons/season-staff/season-current.gif';
            }
        },
        getSeasonImage() {
            if (!this.status_lapse) return '';

            if(this.seasonStreak !== 'lose' && !this.finishedSeason){
              if (this.status_lapse === 'in_progress' || this.status_lapse === 'in_coming' || this.status_lapse === 'completed') {
                return '/img-version2/icons/season-staff/dog.png';
              } else if (this.status_lapse === 'in_warning') {
                return '/img-version2/icons/season-staff/frog.png';
              }
            }else if(this.seasonStreak !== 'lose' && this.finishedSeason){
                return '/img-version2/icons/season-staff/squirrel.png';
            }else{
              return '/img-version2/icons/season-staff/dogSad.png';
            }

        },
        getSeasonTitle(){
            if (!this.status_lapse) return '';

            if(this.seasonStreak !== 'lose' && !this.finishedSeason){
              if (this.status_lapse === 'in_progress' || this.status_lapse === 'in_coming' || this.status_lapse === 'completed' ) {
                return 'Estas en racha';
              } else if (this.status_lapse === 'in_warning') {
                return 'Racha en riesgo';
              }
            }else if (this.seasonStreak !== 'lose' && this.finishedSeason) {
                return 'Completaste tu racha de este mes';
            }else {
              return 'Perdiste tu racha';
            }
        },
         getMissingPoints(){
             axios.get(`get-points-missing-of-season/${this.activeSeason.id}`)
                .then(({ data }) => {
                    this.missingPoints = data.missing_points;
                })
        },
        getSeasonDescription(bubble) {
            if (!this.status_lapse) return '';

            if(this.seasonStreak !== 'lose' && !this.finishedSeason){
              if (this.status_lapse === 'in_progress' || this.status_lapse === 'in_coming' || this.status_lapse === 'completed') {
                return bubble ? '¡ Vas con toda !':'Sigue así para mantener tu racha y alcanzar más recompensas.';
              } else if (this.status_lapse === 'in_warning') {
                return bubble ? ' ¡Estás a un paso de perder tu racha! ' : 'Cumple a tiempo y no dejes que se apague tu llama';
              }
            }else if (this.seasonStreak !== 'lose' && this.finishedSeason) {
                return bubble ? '¡Ganaste!' : 'Completaste tu racha de este mes';
            }else{
                return bubble ? 'Perdiste ' + this.missingPoints + ' puntos y una recompensa en esta racha.' : 'Pero aún puedes ganar más. ¡Sigue participando!';
            }
        },
        getSeasonTitleWinPoints(){
            if (!this.status_lapse) return '';
            if(this.seasonStreak !== 'lose' && !this.finishedSeason){
              if (this.status_lapse === 'in_progress' || this.status_lapse === 'in_coming' || this.status_lapse === 'completed') {
                return '¡Estas en racha!';
              } else if (this.status_lapse === 'in_warning') {
                return '¡Racha en riesgo!';
              }
            }else if (this.seasonStreak !== 'lose' && this.finishedSeason) {
                return '¡Ganaste tu racha!';
            }else{
              return '¡Perdiste tu racha!';
            }
        },
        redirectWinPoints(){
            window.location.href = '/retos'
        },
    }
}


</script>
